import { useCommonMutation, useCommonQuery } from 'hooks';
import { BaseApiResponse, ResultError } from 'modules';
import { PkgAPI } from '../apis/pkg.api';
import { pkgKeys } from '../keys/pkg.key';
import { ReqCheckPkg } from '../models/check';
import { ISettingList, ReqSignUpSettings, ResSignUpSettings } from '../models/info';
import { ReqOtp, ResOtp } from '../models/otp';
import { ReqCreateSignUp, ResCreateSignUp } from '../models/register';

const api = new PkgAPI();

export const useCheckPkgUser = () => {
  return useCommonMutation<BaseApiResponse, ResultError, ReqCheckPkg>({
    mutationKey: pkgKeys.CHECK_PKG_USER(),
    mutationFn: (data) => api.checkPkgUser(data)
  });
};

export const useFetchSignUpSetting = ({ data }: { data: ReqSignUpSettings }) => {
  return useCommonQuery<ReqSignUpSettings, ResSignUpSettings, ResultError, ISettingList>({
    data: data,
    queryKeyFactory: () => pkgKeys.FETCH_SETTINGS(),
    queryFn: () => api.fetchSettings(data),
    options: {
      select: (data) => data.resultObject
    }
  });
};

export const useFetchOtp = () => {
  return useCommonMutation<ResOtp, ResultError, ReqOtp>({
    mutationKey: pkgKeys.FETCH_OTP(),
    mutationFn: (data) => api.fetchOtp(data)
  });
};

export const useCreateSignUp = () => {
  return useCommonMutation<ResCreateSignUp, ResultError, ReqCreateSignUp>({
    mutationKey: pkgKeys.CREATE_SIGN_UP(),
    mutationFn: (data) => api.createSignUp(data)
  });
};
